import comp from "./StudentDetailsLayout";
export default comp;
